import { render, staticRenderFns } from "./SemesterInput.vue?vue&type=template&id=2d3d417a&scoped=true"
import script from "./SemesterInput.vue?vue&type=script&lang=ts"
export * from "./SemesterInput.vue?vue&type=script&lang=ts"
import style0 from "./SemesterInput.vue?vue&type=style&index=0&id=2d3d417a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3d417a",
  null
  
)

export default component.exports